import EIconPanels from 'enums/EIconPanels';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';

export class DragRectangleProps {
  constructor() {
    this.x = 0;
    this.y = 0;
    this.width = 0;
    this.height = 0;
    this.visible = false;
  }
  x: number;
  y: number;
  width: number;
  height: number;
  visible: boolean;
}

export type DragWellDetail = {
  colPos: number;
  rowPos: number;
  x: number;
  y: number;
  dropNumber: number;
  wellNumber: number;
  plateNumber: number;
};

export const dropTargetNodeTypesMap = {
  [ETreeNodeTypes.Protein]: true,
  [ETreeNodeTypes.Screen]: false,
  [ETreeNodeTypes.FragmentScreen]: true,
  [ETreeNodeTypes.Seed]: true,
};

export const treeNodeTypeToLayerTypeMap = {
  [ETreeNodeTypes.Protein]: EIconPanels.ProtienLayer,
  [ETreeNodeTypes.Screen]: EIconPanels.ScreenLayer,
  [ETreeNodeTypes.FragmentScreen]: EIconPanels.FragmentLayer,
  [ETreeNodeTypes.Seed]: EIconPanels.SeedingLayer,
};
